import { render, staticRenderFns } from "./NhNewsPage.vue?vue&type=template&id=bc506062"
import script from "./NhNewsPage.vue?vue&type=script&lang=js"
export * from "./NhNewsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports